<template>
    <div
        :class="[
            'podcast-category-selector__node',
            { 'podcast-category-selector__node--expanded': !treeCollapsed }
        ]"
    >
        <div class="podcast-category-selector__title">
            <Checkbox
                :model-value="category.active"
                theme="inverted"
                :label="category.label"
                @update:model-value="select(category)"
            >
                <template #append>
                    <button
                        v-if="hasChilds"
                        class="podcast-category-selector__tree-toggle"
                        @click="toggleTree"
                    />
                </template>
            </Checkbox>
        </div>
        <transition name="fade-down">
            <div v-if="hasChilds && !treeCollapsed" class="podcast-category-selector__childs">
                <PodcastCategoryNode
                    v-for="child in children"
                    :key="child.name"
                    :category="child"
                    @selected="select"
                />
            </div>
        </transition>
    </div>
</template>

<script>
import { Checkbox } from '@speechki-frontend/shared/ui/forms';

export default {
    name: 'PodcastCategoryNode',
    components: {
        Checkbox
    },
    props: {
        category: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        treeCollapsed: true
    }),
    computed: {
        children() {
            const { children = [] } = this.category || {};
            return children;
        },

        hasChilds() {
            return this.children.length > 0;
        }
    },

    created() {
        const { active = false, childActive = false } = this.category;
        if (active || childActive) {
            this.treeCollapsed = false;
        }
    },

    methods: {
        select(category) {
            this.$emit('selected', category);
        },

        toggleTree() {
            this.treeCollapsed = !this.treeCollapsed;
        }
    }
};
</script>
